import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const generatePriceListDocumentAtom = createMutationAtomFactory(
  'brokerage.generatePriceListDocument',
  (params: {
    priceListId: string;
    priceListType: string;
    templateFileId?: string;
  }) => ({
    pricingGeneratePriceListDocument: {
      __args: {
        input: {
          priceListId: params.priceListId,
          priceListType: params.priceListType,
          templateFileId: params.templateFileId,
        },
      },
      fileId: true,
      workflowId: true,
    },
  }),
);

export const notifyPriceListAtom = createMutationAtomFactory(
  'brokerage.notifyPriceList',
  (params: {
    priceListId: string;
    priceListType: string;
    to: string[];
    cc?: string[];
    bcc?: string[];
    subject?: string;
    body?: string;
    templateFileId?: string;
  }) => ({
    pricingNotifyPriceList: {
      __args: {
        input: {
          priceListId: params.priceListId,
          priceListType: params.priceListType,
          to: params.to,
          cc: params.cc,
          bcc: params.bcc,
          subject: params.subject,
          body: params.body,
          templateFileId: params.templateFileId,
        },
      },
      success: true,
      messageId: true,
      workflowId: true,
      fileId: true,
    },
  }),
);
